<script>
import { marked } from 'marked'
import Favorite from "../lib/favorite.vue"
import channelPrivateButton from '../channel/channel-private-button.vue'
import talkDetail from './talk-detail.vue'

export default {
  components: {Favorite, channelPrivateButton, talkDetail},
  props: {
    speakerId: {type: String, required: true},
    eventShortName: {type: String, default: undefined},
  },

  data() {
    return {
      speaker: {},
      showPastSessions: false,
    }
  },

  computed: {
    shortName() {
      return this.eventShortName || this.$route.params.shortName
    }
  },

  watch: {
    speakerId: {
      handler() {
        this.fetchSpeaker()
      },
    },
  },

  created() {
    this.fetchSpeaker()
  },

  methods: {
    renderMarkdown(text) {
      if (!text) return ''
      return marked.parse(text)
    },

    matchesEvent(session) {
      return !this.eventShortName || this.eventShortName.toUpperCase() === session.event_short_name.toUpperCase()
    },

    currentAndFutureSessions(sessions) {
      if (!sessions) return []
      const now = new Date()
      return sessions.filter(s => this.matchesEvent(s) && new Date(s.end_datetime) >= now)
    },

    pastSessions(sessions) {
      if (!sessions) return []
      const now = new Date()
      return sessions.filter(s => this.matchesEvent(s) && new Date(s.end_datetime) < now).reverse()
    },

    hasPastSessions(sessions) {
      return this.pastSessions(sessions).length > 0
    },

    speakerFullName: function (speaker) {
      return [speaker.title, speaker.first_name, speaker.last_name].join(' ').trim()
    },

    fetchSpeaker: function () {
      let me = this
      this.$api.get(`speakers/${this.speakerId}/`).then(function(response) {
        me.speaker = response.data
      }).catch(function(error){console.error(error)})
    },
  },


}
</script>

<template>
  <div v-if="speaker.content_code" class="card mb-2">
    <favorite attr="speaker" :value="speaker.content_code"
      :obj="speaker" extra-css="p-2 ms-auto"
      @favorite-changed="$emit('favorite-changed', $event)" />
    <img :src="speaker.profile_img_url" class="avatar mx-auto" />
    <div class="card-body text-center">
      <h4 class="card-title mb-0">{{speakerFullName(speaker)}}</h4>
      <p v-if="speaker.job_title" class="text-muted">
        <small>{{speaker.job_title}}</small>
        <small v-if="speaker.sessions_chaired.length"><br>Moderator:in</small>
      </p>
      <p v-if="speaker.company">{{speaker.company}}</p>
      <channel-private-button v-if="speaker.uuid" :contactId="speaker.uuid" />
      <hr>
      <template v-if="speaker.description">
        <h3 class="text-start">Biographie</h3>
        <div class="text-start mb-3" v-html="renderMarkdown(speaker.description)"></div>
      </template>
      <h3 class="text-start">Sessions</h3>
      <talk-detail v-for="talk in currentAndFutureSessions(speaker.sessions)" class="mb-3 text-start" :key="talk.id"
        :talk="talk" :language-display="false" :show-event-name="true"
        @favorite-changed="$emit('mark', $event)" :list-display="true" />

      <hr>
      <h3 class="text-start">Moderierte Sessions</h3>
      <talk-detail v-for="talk in currentAndFutureSessions(speaker.sessions_chaired)" class="mb-3 text-start" :key="talk.id"
        :talk="talk" :language-display="false" :show-event-name="true"
        @favorite-changed="$emit('mark', $event)" :list-display="true" />

      <template v-if="hasPastSessions(speaker.sessions) || hasPastSessions(speaker.sessions_chaired)">
        <hr>
        <div class="c-past-sessions rounded p-3 mb-3" @click.prevent="showPastSessions=!showPastSessions">
          <h3 class="text-start mb-0 d-flex align-items-center">
            <i class="fas fa-history me-2"></i>
            Vergangene Sessions
            <button class="btn btn-outline btn-sm ms-auto">
              <i :class="showPastSessions ? 'fas fa-chevron-down' : 'fas fa-chevron-right'"></i>
            </button>
          </h3>
        </div>
        <template v-if="showPastSessions">
          <talk-detail v-for="talk in pastSessions(speaker.sessions)" class="mb-3 text-start" :key="'past-'+talk.id"
            :talk="talk" :language-display="false" :show-event-name="true"
            @favorite-changed="$emit('mark', $event)" :list-display="true" />
          <template v-if="hasPastSessions(speaker.sessions_chaired)">
            <h5 class="text-start text-muted">Moderiert</h5>
            <talk-detail v-for="talk in pastSessions(speaker.sessions_chaired)" class="mb-3 text-start" :key="'past-chaired-'+talk.id"
              :talk="talk" :language-display="false" :show-event-name="true"
              @favorite-changed="$emit('mark', $event)" :list-display="true" />
          </template>
        </template>
      </template>
    </div>
  </div>
  <div v-else>
    <h2 class="text-center">not found</h2>
  </div>
</template>

<style scoped>

.c-session {
  border-top: 1px solid lightgrey;
}

hr {
  border-color: lightgrey;
}

.avatar {
  height:100px;
  width:100px;
  object-fit:cover;
  border-radius:50%;
  overflow:hidden;
}

.c-past-sessions {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  cursor: pointer;
}

.c-past-sessions:hover {
  background-color: #e9ecef;
}

</style>